import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select as MuiSelect,
  type SelectProps as MuiSelectProps,
} from "@mui/material";

export interface SimpleSelectProps extends Omit<MuiSelectProps, "onChange"> {
  label?: string;
  helperText?: string;
  error?: boolean;
  selectItems: { id: string | number; value: string }[];
  onChange?: (value: string) => void;
}

export const SimpleSelect = ({ label, helperText, error, selectItems, onChange, ...props }: SimpleSelectProps) => {
  const labelId = `${props.name}-label`;

  return (
    <FormControl error={error} fullWidth>
      {label && (
        <InputLabel id={labelId} sx={{ marginLeft: "-0.875rem" }}>
          {label}
        </InputLabel>
      )}
      <MuiSelect
        {...props}
        labelId={labelId}
        onChange={(event) => {
          if (onChange) {
            onChange(event.target.value as string);
          }
        }}
      >
        {selectItems.map((item) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </MuiSelect>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};
